export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg p-8">
      <h1 className="text-4xl font-bold text-amber-500 mb-4">404</h1>
      <p className="text-lg text-gray-700">{"PAGE NOT FOUND"}</p>
      <div className="text-md text-gray-700 mt-5">
        <h2>
          The page you are looking for may have been moved or no longer exists.
        </h2>
        <p>
          If you entered the URL yourself, please check the address and try
          again.
        </p>
      </div>
      <div className="mt-6 flex items-center gap-4">
        <a
          href="https://izzat.xyz"
          className="text-sm mt-2 font-semibold leading-6 text-gray-600 dark:text-white"
        >
          <span aria-hidden="true">←</span> back to home
        </a>
      </div>
    </div>
  );
}
